import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';
import ConfirmModal from './ConfirmModal';

export default function Waitlist() {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirm, setConfirm] = useState(null);

  const load = useCallback(async () => {
    try { setRows(await api.getWaitlist()); }
    catch (_) {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const notify = async (id) => {
    await api.updateWaitlist(id, { status: 'notified' });
    load();
  };

  const remove = (id) => {
    setConfirm({
      message: 'Remove from waitlist?',
      onConfirm: async () => {
        setConfirm(null);
        await api.deleteWaitlist(id);
        load();
      },
    });
  };

  const dateStr = (d) => new Date(d + 'T12:00:00Z').toLocaleDateString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC',
  });

  return (
    <div>
      <h1 style={s.h1}>Waitlist</h1>
      <p style={s.sub}>Customers added by the AI when no availability was found. Contact them when a slot opens.</p>

      {loading ? <div style={{ color: '#64748b', padding: 20 }}>Loading…</div>
      : rows.length === 0 ? (
        <div style={s.empty}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>✅</div>
          <div>Waitlist is empty</div>
        </div>
      ) : (
        <div style={s.tableWrap}>
          <table style={s.table}>
            <thead>
              <tr>{['Name','Phone','Email','Date','Party','Notes','Added','Actions'].map(h =>
                <th key={h} style={s.th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td style={{ ...s.td, fontWeight: 700, color: '#0f172a' }}>{r.name}</td>
                  <td style={s.td}>{r.phone}</td>
                  <td style={s.td}>{r.email || '—'}</td>
                  <td style={s.td}>{dateStr(r.date)}</td>
                  <td style={s.td}>{r.party_size}</td>
                  <td style={{ ...s.td, maxWidth: 180, color: '#64748b' }}>{r.notes || '—'}</td>
                  <td style={{ ...s.td, fontSize: 11, color: '#94a3b8' }}>
                    {new Date(r.created_at).toLocaleDateString()}
                  </td>
                  <td style={s.td}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button style={s.notifyBtn} onClick={() => notify(r.id)}>Mark notified</button>
                      <button style={s.removeBtn} onClick={() => remove(r.id)}>Remove</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {confirm && (
        <ConfirmModal
          message={confirm.message}
          confirmLabel="Remove"
          onConfirm={confirm.onConfirm}
          onCancel={() => setConfirm(null)}
        />
      )}
    </div>
  );
}

const s = {
  h1:        { fontSize: 28, fontWeight: 800, color: '#0f172a', margin: 0, letterSpacing: '-0.5px' },
  sub:       { fontSize: 14, color: '#64748b', marginTop: 4, marginBottom: 24 },
  empty:     { color: '#94a3b8', textAlign: 'center', padding: '60px 0', fontSize: 15 },
  tableWrap: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, overflow: 'hidden', boxShadow: '0 1px 4px rgba(15,23,42,0.06)' },
  table:     { width: '100%', borderCollapse: 'collapse' },
  th:        { padding: '12px 16px', fontSize: 10, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
  td:        { padding: '13px 16px', fontSize: 13, color: '#475569', borderBottom: '1px solid #f1f5f9' },
  notifyBtn: { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 7, padding: '5px 10px', fontSize: 12, color: '#15803d', cursor: 'pointer', whiteSpace: 'nowrap' },
  removeBtn: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 7, padding: '5px 10px', fontSize: 12, color: '#dc2626', cursor: 'pointer' },
};
